import React, { useEffect, useMemo, useState } from 'react';

function StudentStatusPage({ status, message, schoolName }) {
  const isSuccess = status === 'success';
  const [hasClickedTapBuddy, setHasClickedTapBuddy] = useState(false);
  const config = {
    WHATSAPP_NUMBER: process.env.REACT_APP_WHATSAPP_NUMBER || '',
    WHATSAPP_MESSAGE_SUCCESS:
      process.env.REACT_APP_WHATSAPP_MESSAGE_SUCCESS_STUDENT ||
      process.env.REACT_APP_WHATSAPP_MESSAGE_SUCCESS ||
      process.env.REACT_APP_WHATSAPP_MESSAGE ||
      '',
    WHATSAPP_MESSAGE_ERROR: process.env.REACT_APP_WHATSAPP_MESSAGE_ERROR || ''
  };

  const whatsAppLink = useMemo(() => {
    const text = isSuccess ? config.WHATSAPP_MESSAGE_SUCCESS : config.WHATSAPP_MESSAGE_ERROR;
    return `https://api.whatsapp.com/send?phone=${config.WHATSAPP_NUMBER}&text=${text}`;
  }, [
    isSuccess,
    config.WHATSAPP_NUMBER,
    config.WHATSAPP_MESSAGE_SUCCESS,
    config.WHATSAPP_MESSAGE_ERROR
  ]);

  useEffect(() => {
    if (!isSuccess || hasClickedTapBuddy) {
      return undefined;
    }

    const redirectTimer = window.setTimeout(() => {
      window.location.assign(whatsAppLink);
    }, 5000);

    return () => {
      window.clearTimeout(redirectTimer);
    };
  }, [hasClickedTapBuddy, isSuccess, whatsAppLink]);

  return (
    <div className={isSuccess ? 'student-success-screen' : 'student-card-body student-status-body'}>
      {isSuccess ? (
        <>
          <div className="student-success-copy">
            <h2 className="student-success-title">One Last Step 😇</h2>
            <p className="student-success-message">Thank you for sharing your details!</p>
            <p className="student-success-message">
              Click the button below to finish your registration with TAP Buddy.
            </p>
          </div>

          <div className="student-click-card" aria-hidden="true">
            <img
              src={`${process.env.PUBLIC_URL || ''}/external/click-me.svg`}
              alt=""
              className="student-click-asset"
            />
          </div>

          <a
            href={whatsAppLink}
            target="_blank"
            rel="noreferrer noopener"
            className="student-primary-button student-link-button student-success-button"
            onClick={() => setHasClickedTapBuddy(true)}
          >
            <img
              src={`${process.env.PUBLIC_URL || ''}/external/whatsapp-icon.svg`}
              alt="WhatsApp"
              className="student-whatsapp-icon"
            />
            <span className="student-primary-button-text">Finish Registration</span>
          </a>
        </>
      ) : (
        <>
          <span className="student-section-title">REGISTRATION STATUS</span>
          <p className="student-helper-text">{message || 'Registration processing has completed.'}</p>
          <div className="student-status-banner error">
            Student registration could not be completed for {schoolName}. Contact support on WhatsApp.
          </div>
          <a
            href={whatsAppLink}
            target="_blank"
            rel="noreferrer noopener"
            className="student-primary-button student-link-button"
          >
            <img
              src={`${process.env.PUBLIC_URL || ''}/external/whatsapp-icon.svg`}
              alt="WhatsApp"
              className="student-whatsapp-icon"
            />
            <span className="student-primary-button-text">CONTACT SUPPORT</span>
          </a>
        </>
      )}
    </div>
  );
}

export default StudentStatusPage;
